<template>
  <!-- <div class="onePageWrapper"
    :style="'background-image: url(' +getImageSrc() + ');'"> -->
  <div class="icons-on-page">
    <div class="column">
      <!-- Film -->
      <div class="film">
        <div class="" v-for="(_film, index) in pageData.film" :key="'film_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="checkNodeEnv() ? _film.id : interactiveTooltip(_film)"
            :id="_film.id"
            :ref="_film.id"
            :disabled="_film.inactiveIcon"
            @click="showFilm(_film)"
            @mouseover="mousIconOver(_film)"
            @mouseleave="mouseIconOut(_film)"
            :style="setPosition(_film)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_film) },
                { 'icon-image-dense': iconStyleType(_film) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_film.icon)"
            >
              <img draggable="false" :src="imagePath(_film.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_film.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-film"
          :key="'modal-film' + film.id"
          v-if="showModalFilm"
          @close="close('showModalFilm')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-film v-once> </tr-film>
          </div>
        </tr-modal>
      </div>
      <!-- PYTON -->
      <div class="python">
        <div class="" v-for="(_python, index) in pageData.python" :key="'python_' + index">
          <button
            class="button-activator"
            :title="interactiveTooltip(_python)"
            :id="_python.id"
            :ref="_python.id"
            :disabled="_python.inactiveIcon"
            @click="openPython(_python.item.path)"
            @mouseover="mousIconOver(_python)"
            @mouseleave="mouseIconOut(_python)"
            :style="setPosition(_python)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_python) },
                { 'icon-image-dense': iconStyleType(_python) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_python.icon)"
            >
              <img draggable="false" :src="imagePath(_python.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_python.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
      </div>
      <!-- Gallery -->
      <div class="gallery">
        <div class="" v-for="(_gallery, index) in pageData.gallery" :key="'gallery_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(gallery)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_gallery)"
            :id="_gallery.id"
            :ref="_gallery.id"
            :disabled="_gallery.inactiveIcon"
            :class="{ disableButton: disableButton }"
            :style="setPosition(_gallery)"
            @click="showGallery(_gallery)"
            @mouseover="mousIconOver(_gallery)"
            @mouseleave="mouseIconOut(_gallery)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_gallery) },
                { 'icon-image-dense': iconStyleType(_gallery) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_gallery.icon)"
            >
              <img draggable="false" :src="imagePath(_gallery.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_gallery.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-gallery"
          :key="'modal-gallery' + gallery.id"
          v-if="showModalGallery"
          @close="close('showModalGallery')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <tr-gallery slot="body"> </tr-gallery>
        </tr-modal>
      </div>
      <!-- Audio -->
      <div class="audio">
        <div v-for="(_audio, index) in pageData.audio" :key="'audio_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(audio)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_audio)"
            :id="_audio.id"
            :ref="_audio.id"
            :disabled="_audio.inactiveIcon"
            @click="showAudio(_audio)"
            @mouseover="mousIconOver(_audio)"
            @mouseleave="mouseIconOut(_audio)"
            :style="setPosition(_audio)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_audio) },
                { 'icon-image-dense': iconStyleType(_audio) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_audio.icon)"
            >
              <img draggable="false" :src="imagePath(_audio.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_audio.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-audio"
          :key="'modal-audio' + audio.id"
          v-if="showModalAudio"
          @close="close('showModalAudio')"
          :width="31"
          :height="31"
          :audio-css="true"
        >
          <div class="modal-body-flex" slot="body">
            <tr-audio v-once> </tr-audio>
          </div>
        </tr-modal>
      </div>
      <!-- inteactive -->
      <!-- <div class="interacive" v-for="(_interactive, index) in pageData.interactive" , :key="'interactive_' + index">
        <tr-interactive
          :interactive="_interactive"
          :title="interactiveTooltip(_interactive)"
          :ref="_interactive.id"
          :key="'modal-_interactive' + _interactive.item.id"
          :icon="_interactive.icon"
          :style="
            'position:absolute;top:' +
              positionProcess(_interactive.pos).y +
              '%;' +
              'left:' +
              positionProcess(_interactive.pos).x +
              '%;'
          "
        >
        </tr-interactive>
      </div> -->
      <!-- File -->
      <div class="file">
        <div class="" v-for="(_file, index) in pageData.file" :key="'file_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(file)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_file)"
            :id="_file.id"
            :ref="_file.id"
            :disabled="_file.inactiveIcon"
            @click="open(_file.item.path)"
            @mouseover="mousIconOver(_file)"
            @mouseleave="mouseIconOut(_file)"
            :style="setPosition(_file)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_file) },
                { 'icon-image-dense': iconStyleType(_file) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_file.icon)"
            >
              <img draggable="false" :src="imagePath(_file.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_file.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
      </div>
      <!-- External URL -->
      <div class="url">
        <div class="" v-for="(_url, index) in pageData.url" :key="'url_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(url)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_url)"
            :id="_url.id"
            :ref="_url.id"
            :disabled="_url.inactiveIcon"
            @click="openUrl(_url.item.url)"
            @mouseover="mousIconOver(_url)"
            @mouseleave="mouseIconOut(_url)"
            :style="setPosition(_url)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_url) },
                { 'icon-image-dense': iconStyleType(_url) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_url.icon)"
            >
              <img draggable="false" :src="imagePath(_url.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_url.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
      </div>
      <!-- new Game element -->
      <div class="game">
        <div class="" v-for="(_game, index) in pageData.games" :key="'game_' + index">
          <button
            class="button-activator"
            :title="checkNodeEnv() ? _game.id : interactiveTooltip(_game)"
            :id="_game.id"
            :ref="_game.id"
            :disabled="_game.inactiveIcon"
            :class="{ disableButton: disableButton }"
            :style="setPosition(_game)"
            @click="showGame(_game)"
            @mouseover="mousIconOver(_game)"
            @mouseleave="mouseIconOut(_game)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_game) },
                { 'icon-image-dense': iconStyleType(_game) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_game.icon)"
            >
              <img draggable="false" :src="imagePath(_game.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_game.icon, false)" class="icon-on" />
            </div>
          </button>
        </div>
      </div>
      <!--end  new Game element -->
      <!-- MB PRESENTATION-->
      <div class="game">
        <div class="" v-for="(_newPresentation, index) in pageData.presentation" :key="'game_' + index">
          <button
            class="button-activator"
            :title="interactiveTooltip(_newPresentation)"
            :id="_newPresentation.id"
            :ref="_newPresentation.id"
            :disabled="_newPresentation.inactiveIcon"
            :class="{ disableButton: disableButton }"
            :style="setPosition(_newPresentation)"
            @click="changeMbPresentationState(_newPresentation)"
            @mouseover="mousIconOver(_newPresentation)"
            @mouseleave="mouseIconOut(_newPresentation)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_newPresentation) },
                { 'icon-image-dense': iconStyleType(_newPresentation) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_newPresentation.icon)"
            >
              <img draggable="false" :src="imagePath(_newPresentation.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_newPresentation.icon, false)" class="icon-on" />
            </div>
          </button>
        </div>
      </div>
      <!-- MB CROPP IMAGE WITH DRAWING-->
      <div class="game">
        <div class="" v-for="(_newCIWD, index) in pageData.scratchPad" :key="'game_' + index">
          <button
            class="button-activator"
            :title="interactiveTooltip(_newCIWD)"
            :id="_newCIWD.id"
            :ref="_newCIWD.id"
            :disabled="_newCIWD.inactiveIcon"
            :class="{ disableButton: disableButton }"
            :style="setPosition(_newCIWD)"
            @click="changeCroppImageWithDrawingState(_newCIWD)"
            @mouseover="mousIconOver(_newCIWD)"
            @mouseleave="mouseIconOut(_newCIWD)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_newCIWD) },
                { 'icon-image-dense': iconStyleType(_newCIWD) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_newCIWD.icon)"
            >
              <img draggable="false" :src="imagePath(_newCIWD.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_newCIWD.icon, false)" class="icon-on" />
            </div>
          </button>
        </div>
      </div>
      <!-- Scratch launcher -->
      <div class="scratch">
        <div class="" v-for="(_scratchElem, index) in pageData.scratch" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_scratchElem)"
            :id="_scratchElem.id"
            :ref="_scratchElem.id"
            :disabled="_scratchElem.inactiveIcon"
            @click="showScratch(_scratchElem)"
            @mouseover="mousIconOver(_scratchElem)"
            @mouseleave="mouseIconOut(_scratchElem)"
            :style="setPosition(_scratchElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_scratchElem) },
                { 'icon-image-dense': iconStyleType(_scratchElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_scratchElem.icon)"
            >
              <img draggable="false" :src="imagePath(_scratchElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_scratchElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-scratch"
          :key="'modal-scratch' + scratch.id"
          v-if="showModalScratch"
          @close="close('showModalScratch')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-scratch v-once> </tr-scratch>
          </div>
        </tr-modal>
      </div>
      <!--end  Scratch launcher -->
      <!-- Word launcher -->
      <div class="scratch">
        <div class="" v-for="(_wordElem, index) in pageData.word" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_wordElem)"
            :id="_wordElem.id"
            :ref="_wordElem.id"
            :disabled="_wordElem.inactiveIcon"
            @click="showWord(_wordElem)"
            @mouseover="mousIconOver(_wordElem)"
            @mouseleave="mouseIconOut(_wordElem)"
            :style="setPosition(_wordElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_wordElem) },
                { 'icon-image-dense': iconStyleType(_wordElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_wordElem.icon)"
            >
              <img draggable="false" :src="imagePath(_wordElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_wordElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-word"
          :key="'modal-word' + word.id"
          v-if="showModalWord"
          @close="close('showModalWord')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-word v-once> </tr-word>
          </div>
        </tr-modal>
      </div>
      <!--end Word launcher -->
      <!-- Paint launcher -->
      <div class="scratch">
        <div class="" v-for="(_paintElem, index) in pageData.paint" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_paintElem)"
            :id="_paintElem.id"
            :ref="_paintElem.id"
            :disabled="_paintElem.inactiveIcon"
            @click="showPaint(_paintElem)"
            @mouseover="mousIconOver(_paintElem)"
            @mouseleave="mouseIconOut(_paintElem)"
            :style="setPosition(_paintElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_paintElem) },
                { 'icon-image-dense': iconStyleType(_paintElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_paintElem.icon)"
            >
              <img draggable="false" :src="imagePath(_paintElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_paintElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-paint"
          :key="'modal-paint' + paint.id"
          v-if="showModalPaint"
          @close="close('showModalPaint')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-paint v-once> </tr-paint>
          </div>
        </tr-modal>
      </div>
      <!-- PowerPoint launcher -->
      <div class="scratch">
        <div class="" v-for="(_powerpointElem, index) in pageData.powerpoint" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_powerpointElem)"
            :id="_powerpointElem.id"
            :ref="_powerpointElem.id"
            :disabled="_powerpointElem.inactiveIcon"
            @click="showPowerPoint(_powerpointElem)"
            @mouseover="mousIconOver(_powerpointElem)"
            @mouseleave="mouseIconOut(_powerpointElem)"
            :style="setPosition(_powerpointElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_powerpointElem) },
                { 'icon-image-dense': iconStyleType(_powerpointElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_powerpointElem.icon)"
            >
              <img draggable="false" :src="imagePath(_powerpointElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_powerpointElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-powerpoint"
          :key="'modal-powerpoint' + powerpoint.id"
          v-if="showModalPowerPoint"
          @close="close('showModalPowerPoint')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <lm-power-point v-once> </lm-power-point>
          </div>
        </tr-modal>
      </div>
      <!--end Powerpoint launcher -->
      <!-- Pagelink launcher -->
      <div class="scratch">
        <div class="" v-for="(_pagelinkElem, index) in pageData.pagelink" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_pagelinkElem)"
            :id="_pagelinkElem.id"
            :ref="_pagelinkElem.id"
            :disabled="_pagelinkElem.inactiveIcon"
            @click="showPagelink(_pagelinkElem)"
            @mouseover="mousIconOver(_pagelinkElem)"
            @mouseleave="mouseIconOut(_pagelinkElem)"
            :style="setPosition(_pagelinkElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_pagelinkElem) },
                { 'icon-image-dense': iconStyleType(_pagelinkElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_pagelinkElem.icon)"
            >
              <img draggable="false" :src="imagePath(_pagelinkElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_pagelinkElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-pagelink"
          :key="'modal-pagelink' + files.id"
          v-if="showModalPagelink"
          @close="close('showModalPagelink')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-pagelink v-once> </tr-pagelink>
          </div>
        </tr-modal>
      </div>
      <!--end files launcher -->
      <!-- files launcher -->
      <div class="scratch">
        <div class="" v-for="(_filesElem, index) in pageData.files" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_filesElem)"
            :id="_filesElem.id"
            :ref="_filesElem.id"
            :disabled="_filesElem.inactiveIcon"
            @click="showFiles(_filesElem)"
            @mouseover="mousIconOver(_filesElem)"
            @mouseleave="mouseIconOut(_filesElem)"
            :style="setPosition(_filesElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_filesElem) },
                { 'icon-image-dense': iconStyleType(_filesElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_filesElem.icon)"
            >
              <img draggable="false" :src="imagePath(_filesElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_filesElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-files"
          :key="'modal-files' + files.id"
          v-if="showModalFiles"
          @close="close('showModalFiles')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <ps-files v-once> </ps-files>
          </div>
        </tr-modal>
      </div>
      <!--end files launcher -->
      <!-- Coloring launcher -->
      <div class="scratch">
        <div class="" v-for="(_coloringElem, index) in pageData.coloring" :key="'pagedata_' + index">
          <!-- <b-tooltip :content="interactiveTooltip(film)" -->
          <button
            class="button-activator"
            :title="interactiveTooltip(_coloringElem)"
            :id="_coloringElem.id"
            :ref="_coloringElem.id"
            :disabled="_coloringElem.inactiveIcon"
            @click="openColoring(_coloringElem)"
            @mouseover="mousIconOver(_coloringElem)"
            @mouseleave="mouseIconOut(_coloringElem)"
            :style="setPosition(_coloringElem)"
          >
            <div
              class="icon-image"
              :class="[
                { 'icon-image-normal': !iconStyleType(_coloringElem) },
                { 'icon-image-dense': iconStyleType(_coloringElem) },
                { 'hidden-icons': icons },
              ]"
              v-if="!ifNotDefine(_coloringElem.icon)"
            >
              <img draggable="false" :src="imagePath(_coloringElem.icon)" class="icon-off" />
              <img draggable="false" :src="imagePath(_coloringElem.icon, false)" class="icon-on" />
            </div>
          </button>
          <!-- </b-tooltip> -->
        </div>
        <tr-modal
          name="modal-coloring"
          :key="'modal-coloring' + coloring.id"
          v-if="showModalColoring"
          @close="close('showModalColoring')"
          :width="modalWidth"
          :height="modalHeight"
        >
          <div class="modal-body-flex" slot="body">
            <tr-coloring v-once> </tr-coloring>
          </div>
        </tr-modal>
      </div>
      <!--end Coloring launcher -->
    </div>
  </div>
</template>
<script>
import TrModal from '../TrModal/TrModal';
import TrFilm from './TrFilm/TrFilm';
import TrAudio from './TrAudio/TrAudio';
import TrGallery from './TrGallery/TrGallery';
import TrScratch from './TrScratch/TrScratch';
import TrWord from './TrWord/TrWord';
import TrPaint from './TrPaint/TrPaint';
import LmPowerPoint from './LmPowerPoint/LmPowerPoint';
import TrPagelink from './TrPagelink/TrPagelink';
import PsFiles from './PsFiles/PsFiles';
import TrColoring from './TrColoring/TrColoring';
import _ from 'lodash';
const path = require('path');
export default {
  name: 'tr-page',
  props: {
    pageData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    type: {
      type: null,
      default: function () {
        return {};
      },
    },
    icons: {
      type: Boolean,
      default: false,
    },
  },
  mounted: function () {
    // console.log("pageData[game]", this.pageData.game);
  },
  data: function () {
    return {
      // id: "test",
      showModalFilm: false,
      showModalAudio: false,
      showModalGallery: false,
      showModalInteractive: false,
      showModalGame: false,
      showModalScratch: false,
      showModalWord: false,
      showModalPaint: false,
      showModalPowerPoint: false,
      showModalPagelink: false,
      showModalFiles: false,
      showModalColoring: false,
      modalWidth: 100,
      modalHeight: 100,
      disableButton: false,
    };
  },
  components: {
    TrModal,
    TrFilm,
    TrAudio,
    TrGallery,
    TrScratch,
    TrWord,
    TrPaint,
    LmPowerPoint,
    PsFiles,
    TrPagelink,
    TrColoring,
  },
  methods: {
    checkNodeEnv() {
      console.log('NODE_ENV', typeof process.env.NODE_ENV, process.env.NODE_ENV);
      return false;
    },
    changeMbPresentationState(presentation) {
      if (presentation.multibookType) {
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', this.$store.getters.multibookType);
        this.$store.commit('CHANGE_MULTIBOOK_TYPE', presentation.multibookType);
      } else {
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
      }

      this.$store.commit(
        'STATE_PRESENTATION_CONFIG',
        require(`__staticDir/${this.$store.getters.multibookType}/presentation/${presentation.id}/config.js`).default
      );
      this.$store.commit('STATE_PRESENTATION_SHOW', true);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      if (presentation.type == 'interactive-lesson')
        this.$router.push(`/lesson/${this.$store.getters.multibookType}/${presentation.id}`);
      else this.$router.push(`/presentation/${this.$store.getters.multibookType}/${presentation.id}`);
    },
    changeCroppImageWithDrawingState(newCIWD) {
      let multibookMainType = this.$store.getters.multibookType;
      if (newCIWD.multibookType) {
        multibookMainType = newCIWD.multibookType;
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', this.$store.getters.multibookType);
        this.$store.commit('CHANGE_MULTIBOOK_TYPE', newCIWD.multibookType);
      } else {
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
      }
      this.$store.commit('CHANGE_MBCIWD_ACTIVE', true);
      this.$store.commit(
        'CHANGE_MBCIWD_CONFIG',
        require(`__staticDir/${multibookMainType}/scratchPad/${newCIWD.id}/config.js`).default
      );
      this.$store.commit('TOGGLE_CANVAS');
      this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      if (this.textMarkerCanvasActive) {
        this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      }
      this.$store.commit('TOGGLE_UI_DISABLE', !this.allTopLayoutDisable);
    },
    showFilm(filmObj) {
      this.showModalFilm = true;
      // this.$store.commit( 'TOGGLE_UI_DISABLE' );
      // this.$store.commit( 'GALLERY_ACTIVATE' );
      this.$store.commit('CHANGE_FILM_ACTIVE', true);
      this.$store.commit('CHANGE_FILM_CONTENT', filmObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showScratch(scratchObj) {
      this.showModalScratch = true;
      this.$store.commit('CHANGE_SCRATCH_ACTIVE', true);
      this.$store.commit('CHANGE_SCRATCH_CONTENT', scratchObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showWord(wordObj) {
      this.showModalWord = true;
      this.$store.commit('CHANGE_WORD_ACTIVE', true);
      this.$store.commit('CHANGE_WORD_CONTENT', wordObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showPowerPoint(powerpointObj) {
      this.showModalPowerPoint = true;
      this.$store.commit('CHANGE_POWERPOINT_ACTIVE', true);
      this.$store.commit('CHANGE_POWERPOINT_CONTENT', powerpointObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showPaint(paintObj) {
      this.showModalPaint = true;
      this.$store.commit('CHANGE_PAINT_ACTIVE', true);
      this.$store.commit('CHANGE_PAINT_CONTENT', paintObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showPagelink(pagelinkObj) {
      this.showModalPagelink = true;
      this.$store.commit('CHANGE_PAGELINK_ACTIVE', true);
      this.$store.commit('CHANGE_PAGELINK_CONTENT', pagelinkObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showFiles(filesObj) {
      this.showModalFiles = true;
      this.$store.commit('CHANGE_FILES_ACTIVE', true);
      this.$store.commit('CHANGE_FILES_CONTENT', filesObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    openColoring(coloringObj) {
      this.showModalColoring = true;
      this.$store.commit('CHANGE_COLORING_ACTIVE', true);
      this.$store.commit('CHANGE_COLORING_CONTENT', coloringObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showGallery(galleryObj) {
      // this.$store.commit( 'TOGGLE_UI_DISABLE' );
      this.$store.commit('GALLERY_ACTIVATE');
      // this.showModalGallery = true;
      this.showModalGallery = this.galleryActive;
      this.$store.commit('CHANGE_GALLERY_CONTENT', galleryObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showAudio(audioObj) {
      this.showModalAudio = true;
      // this.$store.commit( 'TOGGLE_UI_DISABLE' );
      // this.$store.commit( 'GALLERY_ACTIVATE' );
      if (audioObj.isTransparent) {
        this.$store.commit('DISABLE_PAGE_ICONS', true);
      }
      this.$store.commit('CHANGE_AUDIO_ACTIVE', true);
      this.$store.commit('CHANGE_AUDIO_CONTENT', audioObj);
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    },
    showGame(gameObj) {
      if (gameObj.multibookType) {
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', this.$store.getters.multibookType);
        this.$store.commit('CHANGE_MULTIBOOK_TYPE', gameObj.multibookType);
        let games = this.$store.getters[`${_.upperFirst(gameObj.multibookType)}/games`];
        let newGameObj = games.get(gameObj.id);
        this.$store.dispatch('newGame', newGameObj);
      } else {
        this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
        if (gameObj && _.isObject(gameObj.item) && _.isObject(gameObj.item.gameConfig)) {
          this.$store.commit('CHANGE_GAME_TYPE', 'singleStage');
          this.$store.commit('CHANGE_GAME_ACTIVE', true);
          this.$store.dispatch('setGameObject', gameObj);
          this.$store.dispatch('newGame', gameObj);
          // this.$router.push(`/game/${gameObj.id}`);
        } else if (
          gameObj &&
          _.isArray(gameObj.items) &&
          gameObj.items.reduce((acc, obj) => {
            return acc && obj.item && !_.isEmpty(obj.item.gameConfig);
          }, true)
        ) {
          /**
           * Multi Stage game
           */
          this.$store.commit('CHANGE_GAME_TYPE', 'multiStage');
          this.$store.dispatch('setGameObject', gameObj);
          if (gameObj.multiStageShuffle && gameObj.multiStagePick != 0) {
            this.$store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
            this.$store.commit('SET_GAME_OBJ_ITEMS', gameObj.items);
            this.$store.commit('PICK_GAMEOBJECT', gameObj.multiStagePick);
          } else if (gameObj.multiStageShuffle) {
            this.$store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
            this.$store.commit('SHUFFLE_GAMEOBJECT', _.shuffle(this.$store.getters.gameObj.items));
          }
          this.$store.commit('CHANGE_GAME_ACTIVE', true);
          this.$store.dispatch('newGame', this.$store.getters.gameObj);
        } else {
          console.error('NIE MOZNA ODNALEZC GRY O PODANYCH PARAMETRACH', gameObj);
        }
      }
    },
    close(type) {
      switch (type) {
        case 'showModalScratch':
          this.showModalScratch = false;
          this.$store.commit('CHANGE_SCRATCH_ACTIVE', false);
          break;
        case 'showModalWord':
          this.showModalWord = false;
          this.$store.commit('CHANGE_WORD_ACTIVE', false);
          break;
        case 'showModalPowerPoint':
          this.showModalPowerPoint = false;
          this.$store.commit('CHANGE_POWERPOINT_ACTIVE', false);
          break;
        case 'showModalPaint':
          this.showModalPaint = false;
          this.$store.commit('CHANGE_PAINT_ACTIVE', false);
          break;
        case 'showModalPagelink':
          this.showModalPagelink = false;
          this.$store.commit('CHANGE_PAGELINK_ACTIVE', false);
          break;
        case 'showModalFiles':
          this.showModalFiles = false;
          this.$store.commit('CHANGE_FILES_ACTIVE', false);
          break;
        case 'showModalColoring':
          this.showModalColoring = false;
          this.$store.commit('CHANGE_COLORING_ACTIVE', false);
          break;
        case 'showModalFilm':
          this.showModalFilm = false;
          this.$store.commit('CHANGE_FILM_ACTIVE', false);
          break;
        case 'showModalGallery':
          // this.showModalGallery = false;
          this.$store.commit('GALLERY_DEACTIVATE');
          // console.log(' this.galleryActive', this.galleryActive);
          this.showModalGallery = this.galleryActive;
          break;
        case 'showModalAudio':
          this.showModalAudio = false;
          this.$store.commit('DISABLE_PAGE_ICONS', false);
          this.$store.commit('CHANGE_AUDIO_ACTIVE', false);
          break;
        case 'showModalGame':
          this.showModalGame = false;
          // this.$store.commit('CHANGE_AUDIO_ACTIVE', false);
          break;
        case 'showDemoMessage':
          // this.showDemoMessage = false;
          // this.$store.commit('CHANGE_AUDIO_ACTIVE', false);
          break;
        default:
          console.log('No modal type');
      }
      this.$store.commit('TOGGLE_MODAL_ACTIVE', false);
    },
    imagePath(iconId, off = true) {
      iconId = iconId || 'ikonaCwiczenie';
      let images = require.context('../../assets/icons/book/pageElements/', false, /\.png$/);
      return images('./' + iconId + '' + (off ? '-OFF' : '-ON') + '.png');
    },
    getImageSrc() {
      return 'static/' + this.pageData.imageSrc;
    },
    gallery() {
      return this.pageData.gallery ? this.pageData.gallery.items : [];
    },
    film() {
      return this.pageData.film;
    },
    python() {
      return this.pageData.python;
    },
    audio() {
      return this.pageData.audio;
    },
    game() {
      return this.pageData.games;
    },
    scratch() {
      return this.pageData.scratch;
    },
    word() {
      return this.pageData.word;
    },
    powerpoint() {
      return this.pageData.powerpoint;
    },
    paint() {
      return this.pageData.paint;
    },
    pagelink() {
      return this.pageData.pagelink;
    },
    files() {
      return this.pageData.files;
    },
    coloring() {
      return this.pageData.coloring;
    },
    openPython(link) {
      let spawn = require('child_process').spawn;
      let path = require('path');
      let pathToPython;

      if (require('os').platform() === 'win32') {
        // console.log('WIN 32');
        let basePath = spawn('cmd.exe', [
          '/c', // Argument for cmd.exe to carry out the specified script
          `echo %PATH%`,
        ]);
        basePath.stdout.on('data', (data) => {
          let parseData = JSON.stringify(data.toString('utf8'));
          // let pathArray = parseData.replace(/(\"|\\r\\n)/gm, '').split(';');
          pathToPython = parseData
            .replace(/(\"|\\r\\n)/gm, '')
            .split(';')
            .filter((pathToCheck) => {
              return pathToCheck.includes('Python') && !pathToCheck.includes('Scripts');
            });

          // console.log('pathArray', pathArray);
          // console.log('pathToPython', pathToPython);
          if (pathToPython.length > 0) {
            pathToPython = pathToPython.reduce((accu, item) => {
              return item;
            });
          } else {
            this.showIdleError();
          }

          // Handle data...
        });

        basePath.stderr.on('data', (err) => {
          // Handle error...
          this.showIdleError();
        });

        basePath.on('exit', (code) => {
          console.log('code', code);
          // Handle exit
          if (code === 0 && pathToPython != '') {
            this.runPythonCommand(pathToPython, link);
          }
        });
      } else {
        // console.log('Linux');
        this.runPythonCommand(pathToPython, link);
      }
    },
    runPythonCommand(pathToPython, link) {
      let spawn = require('child_process').spawn;
      let path = require('path');
      let pythonCommand;
      let base;

      let pathBasePathToIDLE;
      if (require('os').platform() === 'win32') {
        pathBasePathToIDLE = path.join(pathToPython, '/Lib/idlelib', 'idle.pyw');
        console.log('pathBasePathToIDLE', pathBasePathToIDLE);
        if (link) {
          console.log('PAJTONG --> ' + link);
          base = path.posix.resolve();
          let pathLink = path.join(base, '/static/', this.$store.getters.multibookType, link);
          pythonCommand = spawn('cmd.exe', [
            '/c', // Argument for cmd.exe to carry out the specified script
            `python`, // Path to your file
            `${pathBasePathToIDLE}`,
            `${pathLink}`,
          ]);
          // this.open(link);
        } else {
          pythonCommand = spawn('cmd.exe', [
            '/c', // Argument for cmd.exe to carry out the specified script
            `python`, // Path to your file
            `${pathBasePathToIDLE}`,
          ]);
        }
        pythonCommand.stdout.on('data', (data) => {
          // Handle data...
        });

        pythonCommand.stderr.on('data', (err) => {
          // Handle error...
          this.showPythonError();
        });

        pythonCommand.on('exit', (code) => {
          // Handle exit
        });
      } else {
        console.log('Linux');
        if (link) {
          console.log('PAJTONG --> ' + link);
          base = path.posix.resolve();
          let pathLink = path.join(base, '/static/', this.$store.getters.multibookType, link);
          pythonCommand = spawn('idle', [pathLink], { shell: true });
        } else {
          pythonCommand = spawn('idle', { shell: true });
        }
        pythonCommand.stdout.on('data', (data) => {
          console.log('data', data);
          // Handle data...
        });

        pythonCommand.stderr.on('data', (err) => {
          // Handle error...
          this.showIdleError();
        });

        pythonCommand.on('exit', (code) => {
          // Handle exit
        });
      }
    },
    showPythonError() {
      if (!process.env.VUE_APP_IS_WEB) {
        const { dialog } = require('electron').remote;

        let title = 'Brak kompilatora języka Python';
        let messageWin =
          'Nie można odnaleźć zainstalowanego kompilatora języka Python lub ścieżka do niego nie jest dodana do zmiennej systemowej PATH.';
        let messageLinux =
          'Nie można odnaleźć zainstalowanego kompilatora języka Python lub ścieżka do niego nie jest dodana do zmiennej systemowej PATH.';
        if (require('os').platform() === 'win32') {
          dialog.showErrorBox(title, messageWin);
        } else {
          dialog.showErrorBox(title, messageLinux);
        }
      } else {
        console.log('THIS IS WEB');
        this.$store.commit('CHANGE_DEMO_ACTIVE', true);
      }
    },
    showIdleError() {
      if (!process.env.VUE_APP_IS_WEB) {
        const { dialog } = require('electron').remote;
        let title = 'Brak kompilatora języka Python lub środowiska IDLE Python IDE';
        let messageWin =
          'Nie można odnaleźć zainstalowanego kompilatora języka Python lub nie można odnalźć środowiska IDLE Python IDE';
        let messageLinux =
          'Nie można odnaleźć zainstalowanego kompilatora języka Python lub nie można odnalźć środowiska IDLE Python IDE';

        if (require('os').platform() === 'win32') {
          dialog.showErrorBox(title, messageWin);
        } else {
          dialog.showErrorBox(title, messageLinux);
        }
      } else {
        console.log('THIS IS WEB');
        this.$store.commit('CHANGE_DEMO_ACTIVE', true);
      }
    },
    open(link) {
      const path = require('path');
      let fullLink;
      let base;
      if (!process.env.VUE_APP_IS_WEB) {
        if (require('os').platform() === 'win32') {
          console.log('WIN32');
          base = path.win32.resolve();
        } else {
          console.log('LINUX');
          base = path.posix.resolve();
        }
        fullLink = path.join(base, '/static/', this.$store.getters.multibookType, link);
        this.$electron.shell.openItem(fullLink);
      } else {
        let tmplink = link;
        let url = document.createElement('a');
        url.href = '/static/' + this.$store.getters.multibookType + '/' + tmplink;
        url.download = tmplink.substr(tmplink.lastIndexOf('/') + 1);
        console.log(url);
        url.click();

        // this.openUrl(window.location.origin + '/' + tmplink);
        // console.log('THIS IS WEB');
        // this.$store.commit('CHANGE_DEMO_ACTIVE', true);
      }
    },
    openUrl(link) {
      if (process.env.VUE_APP_IS_WEB) {
        window.open(link, '_blank');
      } else {
        this.$electron.shell.openExternal(link);
      }
    },
    positionProcess(
      pos,
      boxSize = {
        width: this.$store.getters.realWidth,
        height: this.$store.getters.realHeight,
      }
    ) {
      let newPos = _.cloneDeep(pos);
      newPos.y += this.rectangleOffset.y;
      newPos.y = newPos.y >= boxSize.height ? boxSize.height - this.getProportionalIconHeight : newPos.y;
      return {
        x: (newPos.x * 100) / boxSize.width,
        y: (newPos.y * 100) / boxSize.height,
      };
    },
    iconON(id) {
      let query = '#' + id;
      let element = document.querySelector(query);
      element.classList.add('borderHover');
    },
    iconOFF(id) {
      let query = '#' + id;
      let element = document.querySelector(query);
      element.classList.remove('borderHover');
    },
    mousIconOver(data) {
      if (_.isArray(data.rectangle)) {
        _.each(data.rectangle, (item) => {
          this.iconON(item.id);
        });
      } else {
        if (data.rectangle && data.rectangle.id) {
          this.iconON(data.rectangle.id);
        }
      }
    },
    mouseIconOut(data) {
      if (_.isArray(data.rectangle)) {
        _.each(data.rectangle, (item) => {
          this.iconOFF(item.id);
        });
      } else {
        if (data.rectangle && data.rectangle.id) {
          this.iconOFF(data.rectangle.id);
        }
      }
    },
    interactiveTooltip(pageData) {
      let tooltip = '';
      switch (pageData.icon) {
        case 'ikonaScenariusz':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Scenariusz';
          break;
        case 'ikonaTekst':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Dokument tekstowy';
          break;
        case 'ikonaPaint':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Paint';
          break;
        case 'ikonaPowerPoint':
          tooltip = pageData.tooltip ? pageData.tooltip : 'PowerPoint';
          break;
        case 'ikonaPagelink':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Pagelink';
          break;
        case 'ikonaColoring':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Obrazki do kolorowania';
          break;
        case 'ikonaPrezentacja':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Prezentacja';
          break;
        case 'ikonaTablice':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Tablica demonstracyjna';
          break;
        case 'ikonaTabela':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Arkusz kalkulacyjny';
          break;
        case 'ikonaCwiczenie':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Ćwiczenie';
          break;
        case 'ikonaFilm':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Film';
          break;
        case 'ikonaGaleria':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Galeria zdjęć';
          break;
        case 'ikonaMuzyka':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Muzyka';
          break;
        case 'ikonaSluchowisko':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Słuchowisko';
          break;
        case 'ikonaZdjecie':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Zdjęcie';
          break;
        case 'ikonaWWW':
          tooltip = pageData.tooltip ? pageData.tooltip : pageData.item.url;
          break;
        case 'ikonaBrudnopis':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Powiększenie ćwiczenia';
          break;
        case 'ikonaNotatka':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Powiększenie ćwiczenia';
          break;
        case 'ikonaScratch':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Scratch';
          break;
        case 'ikonaPython':
          tooltip = pageData.tooltip ? pageData.tooltip : 'Python';
          break;
        case 'ikona3d':
          tooltip = pageData.tooltip ? pageData.tooltip : '3D';
          break;
      }
      return tooltip;
    },
    ifNotDefine(iconName) {
      return _.isUndefined(iconName) || _.isEmpty(iconName);
    },
    iconStyleType(item) {
      if (item.dense) {
        return true;
      }
      return false;
    },
    setPosition(elem) {
      return {
        position: 'absolute',
        top: `${this.positionProcess(elem.pos).y}%`,
        left: `${this.positionProcess(elem.pos).x}%`,
      };
    },
  },
  computed: {
    textMarkerCanvasActive() {
      return this.$store.getters.textMarkerCanvasActive;
    },
    rectangleOffset() {
      return this.$store.getters.rectangleOffset;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    galleryActive() {
      return this.$store.getters.galleryActive;
    },
    getProportionalIconHeight() {
      let value = parseInt(
        (this.$store.getters.realHeight *
          ((this.$store.getters.iconSize * 100) / this.$store.getters.mainContenHeight)) /
          100
      );
      return value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';

.disableButton {
  display: none !important;
}
.hidden-icons {
  display: none;
}
.icon-image-normal {
  width: $iconWidth;
  height: $iconHeight;
}
.icon-image-dense {
  width: calc(#{$iconWidth * 75 / 100});
  height: calc(#{$iconHeight * 75 / 100});
}
.icon-image {
  position: relative;
  visibility: visible;
  opacity: 1;
  transition: visibility 0s, opacity 0.3s ease-in;
}
.icon-image .icon-off {
  visibility: visible;
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  transition: visibility 0s, opacity 0.3s ease-out;
}
.icon-image .icon-on {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  transition: visibility 0s, opacity 0.3s ease-out;
}
.icon-image:hover .icon-on {
  visibility: visible;
  opacity: 1;
  transition: visibility 0s, opacity 0.3s ease-in;
}

.fakeHover {
  visibility: visible !important;
  opacity: 1 !important;
}
.modal-body-flex {
  height: 100%;
}
</style>
